import styled from 'styled-components';
import { Tag, Drawer } from 'antd';

export const StyledCompareBar = styled.div`
  padding-bottom: 3px;
  margin-bottom: 10px;
  border-bottom: 1px solid #aaa;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
`;

export const ButtonWrapper = styled.div`
  margin: 0 2.5px;
`;

export const FilterBarFooter = styled.div`
  display: flex;
  flex-direction: row-reverse;

  button {
    margin: 0 5px;
  }
`;

export const StyledTag = styled(Tag)`
  margin-right: 3px;
  margin-bottom: 3px;
`;

export const StyledAndTag = styled(StyledTag)`
  margin-left: 5px;
  margin-right: 8px;
`;

export const StyledOrTag = styled(StyledTag)`
  color: inherit;
`;

export const FilterNameText = styled.span`
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-close {
    height: auto;
    width: auto;
    position: relative;
  }

  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }

  .ant-drawer-body {
    padding: 3px 10px;
  }

  .ant-drawer-header {
    padding: 3px 10px;
  }

  .ant-drawer-footer {
    padding: 4px 8px;
  }
`;

export const VerticalBar = styled.span`
  position: absolute;
  width: 0.3rem;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${(props) => props.color};
  z-index: 1;
`;

export const StyledFilterTag = styled(Tag)<{
  $highlight: string;
}>`
  position: relative;
  font-size: 12px;
  padding: 3px 8px;
  align-self: center;
  cursor: pointer;
  background-color: ${(props) => props.$highlight};
  margin-inline-end: 3px;
`;
